import React, { Fragment } from "react";

export default (
  <>
    <path d="M23.4985 6.1858c-.276-1.0393-1.0893-1.8578-2.1219-2.1356C19.505 3.5454 12 3.5454 12 3.5454s-7.505 0-9.3766.5048C1.5908 4.328.7775 5.1465.5015 6.1858 0 8.0696 0 12 0 12s0 3.9304.5015 5.8141c.276 1.0394 1.0893 1.8578 2.1219 2.1357 1.8716.5047 9.3766.5047 9.3766.5047s7.505 0 9.3766-.5047c1.0326-.2779 1.8459-1.0963 2.1219-2.1357C24 15.9304 24 12 24 12s0-3.9304-.5015-5.8142zM10 15.5685v-7.137l6.2727 3.5686L10 15.5685z" />
  </>
);
